import { createContext } from 'react';

export interface RealtimeContextType {
  outletId: string | null;
  setOutletId: (id: string | null) => void;
  addEventListener: (
    type: string,
    listener: (event: MessageEvent) => void
  ) => () => void;
}

export const RealtimeContext = createContext<RealtimeContextType | undefined>(
  undefined
);
